module.exports = __webpack_public_path__ + "static/media/microwave1.65ea346b.png";